// extracted by mini-css-extract-plugin
module.exports = {"search":"MediaPage_search__2yFFh","card":"MediaPage_card__33iAh","image":"MediaPage_image__2ObXA"};